import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { logoutUser } from "../../redux/reducers/user-authentication/authentication-action";
import { updateStorageOnClearCart } from "../../containers/SupplierDetail/ProductDetailModal/ProductDetails/product-cart-detail-utils";
import { registerSocketListener } from "../../web-socket";
import { DEVICE_LOGOUT } from "../../web-socket/socket-events";
import { getDeviceId } from "../../utils/common-utils";

const useAccountSession = () => {
  const dispatch = useDispatch();
  const [confirmingLogout, setConfirmingLogout] = useState(false);

  const performLogout = () => {
    dispatch(
      logoutUser(() => {
        updateStorageOnClearCart(true);
        window.location.replace("/");
      })
    );
  };

  useEffect(() => {
    registerSocketListener(DEVICE_LOGOUT, ({ device_id }) => {
      const storedDeviceId = getDeviceId();

      if (!storedDeviceId || device_id === storedDeviceId) performLogout();
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    confirmingLogout,
    requestLogout: () => setConfirmingLogout(true),
    cancelLogout: () => setConfirmingLogout(false),
    performLogout,
  };
};

export default useAccountSession;
